var giphy_viewer_default = {
  "giphyWrapper": "u5pE8",
  "giphy_player": "Qzl7-",
  "playIcon": "_5YyX8",
  "gifRatio": "BX3lF"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
